import { c as _c } from "react/compiler-runtime";
import { IconTextLayout } from "@/app/(main)/(club)/mes-clubs/[id]/components/modal/event/read/header/icon-text-layout";
import Icon from "@/components/icon";
import { EventRead } from "@/TS/Interfaces/global_interfaces";
interface EventReadTimeProps {
  event: EventRead;
}
export const EventReadTime: React.FC<EventReadTimeProps> = t0 => {
  const $ = _c(8);
  const {
    event
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon size={23} icon="time" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== event.startDate) {
    t2 = new Date(event.startDate || "").toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit"
    }).replace(":", "h");
    $[1] = event.startDate;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== event.endDate) {
    t3 = new Date(event.endDate || "").toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit"
    }).replace(":", "h");
    $[3] = event.endDate;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <IconTextLayout>{t1}<p>{t2}{" "}-{t3}</p></IconTextLayout>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};